/**
 * Utility functions for role checking
 * Handles both uppercase (CLUB_ADMIN) and lowercase (club_admin) role formats
 */

export const isClubAdmin = (role?: string): boolean => {
  if (!role) return false;
  return role === 'club_admin' || role === 'CLUB_ADMIN';
};

export const isStudent = (role?: string): boolean => {
  if (!role) return false;
  return role === 'student' || role === 'STUDENT';
};

export const isSuperAdmin = (role?: string): boolean => {
  if (!role) return false;
  return role === 'super_admin' || role === 'SUPER_ADMIN';
};

export const hasRole = (role?: string, requiredRole?: string): boolean => {
  if (!role || !requiredRole) return false;
  const normalizedRole = role.toUpperCase().replace('-', '_');
  const normalizedRequired = requiredRole.toUpperCase().replace('-', '_');
  return normalizedRole === normalizedRequired;
};
